import { envConfig } from "../env";
import GADConfig from "../google-automated-discount";
import type { MarketConfiguration } from "./const";
import {
  ContentfulEnum,
  CurrencyEnum,
  ElevateMarketEnum,
  LocaleEnum,
  MarketEnum,
  RegionEnum,
  ServiceLocaleEnum,
} from "./const";

const ngEuMerchant = "738826960";

const spain: MarketConfiguration = {
  code: MarketEnum.es,
  label: "Spain",
  descriptiveLabel: "Spanish",
  testfreaksClientId: envConfig.NEXT_PUBLIC_EU_TESTFREAKS_CLIENT_ID,
  searchEngineUrl: envConfig.NEXT_PUBLIC_SEARCH_ENGINE_URL,
  contentfulLocale: ContentfulEnum.en,
  contentfulCountry: "Spain",
  locale: LocaleEnum.es,
  serviceLocale: ServiceLocaleEnum.es,
  language: {
    code: "en",
    label: "English",
    flag: "gb",
  },
  currency: CurrencyEnum.eur,
  link: "https://www.no-ga.com/en-es",
  termsSlug: "terms-online",
  loop54Market: MarketEnum.es,
  adyenMarket: MarketEnum.es,
  elevateMarket: ElevateMarketEnum.eu,
  freeShippingEnabled: false,
  freeShippingThreshold: 100,
  externalStoreId: "ecom-noga",
  searchPathName: "search",
  adyenCheckoutEnabled: true,
  walleyCheckoutEnabled: false,
  hasTrustPilot: false,
  region: RegionEnum.europe,
  googleAutomatedDiscounts: {
    allowedInTest: {
      allowedMerchants: new Set([ngEuMerchant, GADConfig.testMerchantId]),
      allowedPublicKeys: [
        GADConfig.testPublicKey,
        GADConfig.googleProductionPublicKey,
      ],
    },
    allowedInProd: {
      allowedMerchants: new Set([ngEuMerchant]),
      allowedPublicKeys: [GADConfig.googleProductionPublicKey],
    },
  },
  norceImageCdn: ["local", "dev", "stage"].includes(
    process.env.NEXT_PUBLIC_ENVIRONMENT ?? "",
  )
    ? "https://media.stage.cdn-norce.tech/1413"
    : "https://cdn.no-ga.com",
};

export default spain;
